export const tradeReviewLocation = "/reports/exchbusiness/tradereview";
